import type { PixelClient } from "../client.js";
import { pageContext, pageProps } from "./page-context.js";

export interface NewSessionDetail {
  sessionId: string;
}

/**
 * Emits session_start exactly once at the beginning of a new idle window and announces it to
 * storefront UI code. The browser event lets platform plugins react without reimplementing
 * cookie/session logic. A returning visitor (seen cookie from a prior visit) additionally
 * emits return_visit (event-types.md: "visitor_id cookie seen before").
 */
export function startPageSession(client: PixelClient): void {
  const ctx = pageContext();
  const session = client.currentSession(ctx);
  if (!session.isNew) return;

  // Read before track(): the first build() marks the browser as seen.
  const { returning } = client.currentVisitor();

  void client.track("session_start", pageProps(), ctx);
  if (returning) {
    void client.track("return_visit", pageProps(), ctx);
  }

  if (typeof window !== "undefined" && typeof CustomEvent !== "undefined") {
    window.dispatchEvent(
      new CustomEvent<NewSessionDetail>("retarget:new-session", {
        detail: { sessionId: session.sessionId },
      }),
    );
  }
}
